





















import { Component, Prop, Vue } from 'vue-property-decorator';
import EditorCell from '@/editor/editor-block-view/components/EditorCell.vue';
import { ColumnCount, ICell, IMergeValues } from '@/editor/types';
import { EBlockWidth, ERowType } from '@/editor/types/enums';

@Component({
  components: {
    EditorCell,
  },
  data: () => ({
    ERowType,
  }),
})
export default class EditorRowColumns extends Vue {
  @Prop({ default: 3 }) columnCount: ColumnCount;
  @Prop() cells: ICell[];
  @Prop() mergeValues: IMergeValues;
  @Prop() blockWidthClass: EBlockWidth;
  @Prop() isPdfViewer: boolean;
  @Prop() isBlockToggled: boolean;
  @Prop() pageWidth: number;

  get cellWidth() {
    return 100 / this.columnCount;
  }

  isParentFirstChild(index: number): boolean {
    return index === 0;
  }

  isParentLastChild(index: number): boolean {
    return index === this.cells.length - 1;
  }
}
